import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    radio: {
        '& .MuiIconButton-label': {
            color: theme.palette.text.main
        }
    }
}));